import classNames from "classnames";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Outlet, useParams } from "react-router-dom";

import { selectFeatureFlag } from "shared/reducers/sysReducer";

import { useAppSelector } from "app/hooks";
import {
  useSelectedLab,
  useSelectedLabStation,
} from "hooks/useSelectedLabStation";
import MaintenanceBannerController from "ui/components/MaintenanceBannerController";

import StationButtons from "./StationButtons";
import StationDocument from "./StationDocument";

const StationNew = ({
  stationDocumentWrapper,
}: {
  stationDocumentWrapper?: boolean;
}) => {
  const lab = useSelectedLab();
  const station = useSelectedLabStation();
  const { document_id } = useParams();
  const [crosshair, setCrosshair] = useState(false);
  const pathCase = useAppSelector((state) => state.case);
  const lisAltClickScanning = useAppSelector((state) =>
    selectFeatureFlag(state, "lisAltClickScanning")
  );

  function downHandler({ key }: KeyboardEvent) {
    if (key === "Alt" && lisAltClickScanning) {
      setCrosshair(true);
    }
  }
  const upHandler = ({ key }: KeyboardEvent) => {
    if (key === "Alt") {
      setCrosshair(false);
    }
  };
  useEffect(() => {
    window.addEventListener("keydown", downHandler);
    window.addEventListener("keyup", upHandler);
    return () => {
      window.removeEventListener("keydown", downHandler);
      window.removeEventListener("keyup", upHandler);
    };
  }, []);

  return (
    <div
      className={classNames("TopLevel", {
        Crosshair: crosshair,
      })}
    >
      <Helmet>
        <title>{`${station?.name}`}</title>
      </Helmet>
      <MaintenanceBannerController />
      <StationButtons />
      {lab?.settings?.paperless_grossing?.active &&
      stationDocumentWrapper &&
      !Number.isNaN(Number(document_id)) &&
      pathCase?.documents?.map((d) => d.id).includes(Number(document_id)) ? (
        <div className="StationDocumentWrapper">
          <Outlet />
          <StationDocument documents={pathCase?.documents} />
        </div>
      ) : (
        <Outlet />
      )}
    </div>
  );
};

export default StationNew;
